<template>
  <v-container>
    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        transition="dialog-transition">
        <v-card>
          <v-toolbar color="primary" dark dense>
            <img 
              src="@/assets/nihr-logo.svg" 
              alt="National Institute for Health and Care Research"
              width="160">
            <v-toolbar-title class="title">Privacy policy</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p class="text-xs-left body-2 font-weight-medium"> {{privacyPolicy.policy}} </p>
            <p class="text-xs-left body-2 font-weight-medium">{{privacyPolicy.contactText}} <a :href="targetEmail" target='_blank'>{{privacyPolicy.contactEmail}}</a>  </p>
          </v-card-text>  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              flat 
              outline
              @click="dialog = !dialog">
                Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12 sm8 md8>
        <v-card>
          <v-toolbar
            dense
            flat
            card
            dark
            color="primary"
          >
          <img 
            src="@/assets/nihr-logo.svg" 
            alt="National Institute for Health and Care Research"
            width="160">
          </v-toolbar>
          <v-card-text>
            <div class="text-xs-center display-1" id="card-header-text">
              {{appTitle}}
            </div>
            <div id="firebaseui-auth-container"></div> 
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              color="info"
              flat
              small
              @click="dialog = !dialog"
            >Privacy Policy</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer color="rgba(0,0,0,0.0)">
      <v-layout row justify-center>
        <span style="color:#ACBCC3">
          &copy;{{thisYear}} CRN North East and North Cumbria
        </span>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>  
import firebase from 'firebase/app';
import 'firebase/auth';

import firebaseui from 'firebaseui'

export default {
  name: 'login',
  data () {
    return {
      dialog: false
    }

  },
  mounted() {
    this.$store.dispatch('updateAppTitle')
    this.$store.dispatch('updatePrivacyPolicy')
    var uiConfig = {
      signInSuccessUrl: '/home',
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID
          // instructions say to include a sign in method
          // but this allows for signing in from an eamil link
          // when all we want is a verifiaction process for the email address
          // signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD
        }
        ],
        // Required to disable use of a credential helper.
        credentialHelper: firebaseui.auth.CredentialHelper.NONE
      };
    let ui = firebaseui.auth.AuthUI.getInstance()
    if(!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    ui.start('#firebaseui-auth-container', uiConfig)
  },
  computed: {
    thisYear: function() {
      return new Date().getFullYear()
    },
    privacyPolicy: function() {
      return this.$store.getters.getPrivacyPolicy
    },
    targetEmail: function () {
      return "mailto: "+this.privacyPolicy.contactEmail
    },
    appTitle: function () {
      // get the configuration data from the store
      return this.$store.getters.getAppTitle
    }
  }
}
</script>


<style scoped>  
  #card-header-text {  
    margin-top: 5px;
    margin-bottom: 25px;
  }

  p {
    white-space: pre-line;
  }
</style>